import React from 'react';
import { Paper, Typography, Box } from '@mui/material';

function KpiPanel({ title, value, chartData, width, Chart, sx }) {
  return (
    <Paper sx={{ p: 2, textAlign: 'center', width, ...sx }}>
      <Typography variant="h6" gutterBottom color="text.secondary">
        {title}
      </Typography>
      {chartData && Chart ? (
        <Chart data={chartData} />
      ) : (
        <Box>
          {Array.isArray(value) ? (
            value.map((v, i) => (
              <Typography key={i} variant="h4" sx={i > 0 ? { mt: 1 } : {}}>
                {v}
              </Typography>
            ))
          ) : (
            <Typography variant="h4">
              {value}
            </Typography>
          )}
        </Box>
      )}
    </Paper>
  );
}

export default KpiPanel;
